'use strict';

angular.module('atex.art').factory('ArtCommonServices',['$rootScope', '$q','$timeout', '$window', '$location', '$route',
                                  'ArtPrintData', 'ArtContentStore', 'ArtInboxOptions','ArtLockingService',
  function($rootScope, $q, $timeout, $window, $location, $route,
                ArtPrintData, ArtContentStore, ArtInboxOptions,ArtLockingService) {
    function ArtCommonServices() {}

    ArtCommonServices.shouldClose = function() {
      if ($window.opener) {
        return true;
      }

      if ( $route.current && $route.current.params ) {
        if ($route.current.params.clwnd) {
          return true;
        }

        if (!$route.current.params.fromList) {
          return true;
        }
      }
      return false;
    };

    ArtCommonServices.close = function() {
      if (ArtCommonServices.shouldClose()) {
        if ($window.opener) {
          $window.setTimeout(function () {
            window.open("about:blank", "_self");
          }, 500);
          $window.close();
        } else {
          $location.path('/');
        }
      } else {
        $location.path('/');
      }
    };

    ArtCommonServices.unlock = function(contents) {
      return $q(function(resolve) {
        if (contents && contents.length > 0) {
          var cleanContents = [];
          contents.forEach(function (content) {
            if (content.startsWith('contentid/')) {
              content = content.replace('contentid/', '');
            }
            cleanContents.push(content);
          });

          ArtLockingService.unlock(cleanContents).then(function(){
            resolve(true);
          });
        } else {
          resolve(true);
        }
      });
    };

    function isArrayOfContentId(object, path){
      if( path.indexOf('_type') !== -1) {
        return false;
      }
      var element_types = atex.onecms.ObjectUtils.getByPath(object, path + '_element_types') || null;
      if( element_types !== null ) {
        var type = atex.onecms.ObjectUtils.getByPath(object, path + '_type');
        return type.indexOf('com.atex.onecms.content.ContentId') !== -1;
      }
      return false;
    }

    ArtCommonServices.unlockResources = function(article) {
      var dataPath = 'data/aspects/contentData/data';
      var data = atex.onecms.ObjectUtils.getByPath(article, dataPath) || [];
      var promises = Object.keys(data)
        .filter(function(key){
          return isArrayOfContentId(article, dataPath + '/' + key);
        }).map(function(key) {
          var objectArray = atex.onecms.ObjectUtils.getByPath(article, dataPath + '/' + key);
          return ArtCommonServices.unlock(objectArray);
        });
      return $q.all(promises);
    };

    ArtCommonServices.unlockArticle = function(article) {
      return $q(function(resolve) {
        if (article.local.existsOnServer && article.local.persisted) {
          ArtLockingService.unlock([article.meta.id]).then(function() {
            resolve(true);
          });
        } else {
          resolve(true);
        }
      });
    };

    ArtCommonServices.isGroupDefault = function( template ) {
      if ( (typeof template !== 'undefined') && (typeof template.group !== 'undefined') && (typeof template.group.default !== 'undefined') ) {
        return template.group.default !== 0;
      }

      return false;
    };

    ArtCommonServices.getGroupType = function( template ) {
      if (typeof template !== 'undefined' && typeof template.group !== 'undefined' && typeof template.group.type !== 'undefined' ) {
        return template.group.type;
      }

      return undefined;
    };

    ArtCommonServices.getTemplateFor = function (content,templates) {
      /**
       * This is where we would try to find template information in the data itself.
       * Note that even if the data has template information in it, the template has
       * to exist in the template list for the tool (Contributor Tool).
       */

      var template;
      var createdWithTemplateId = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/atex.OneCMS/data/createdWithTemplate');

      if (typeof createdWithTemplateId !== 'undefined') {
        template = _.find(templates, function (template) {
          return template.id === createdWithTemplateId;
        });
      }

      /**
       * Regardless of whether or not there is creation template information in the
       * content data, we fallback to the first template (in our list) that operates
       * on the same content and group.
       */
      if (typeof template === 'undefined') {
        template = _.find(templates, function (template) {
          return ArtCommonServices.isGroupDefault( template ) &&
            ( template.type !== 'undefined' ) &&
            ( template.type === content.data.aspects.contentData.data._type);
        });
      }

      /**
       * Lastly we fallback to the first template (in our list) that operates
       * on the same content / data type.
       */
      if (typeof template === 'undefined') {
        template = _.find(templates, function (template) {
          return typeof template.type !== 'undefined' && template.type === content.data.aspects.contentData.data._type;
        });
      }

      return template;
    };

    ArtCommonServices.isSendable = function(article) {
      return (article.local.valid && !article.local.conflict && !article.isBeingSent && typeof (article) !== 'undefined');
    };

    function replace(oldId, newId, resources) {
      var positions  = resources.indexOf(oldId);
      if (positions > -1) {
        resources[positions] = newId;
      }
      return resources;
    }

    ArtCommonServices.storeToServer = function(article,templates, master) {
      return $q(function(resolve,reject) {
        if (!ArtCommonServices.isSendable(article)) {
          reject(false);
        }

        $rootScope.$broadcast("onecms:edit-content",false);

        delete article.sendError;
        delete article.sendCancelled;

        article.isBeingSent = true;
        article.template = ArtCommonServices.getTemplateFor(article,templates);

        ArtPrintData.flushPrintUpdates(article).then(function (article) {
          var oldId = article.meta.id;
          ArtContentStore.sendToServer(article).then(function () {
            delete article.isBeingSent;

            if( master ) {
              if (article.data.id !== master.data.id) {
                var dataPath = 'data/aspects/contentData/data';
                var data = atex.onecms.ObjectUtils.getByPath(master, dataPath) || [];
                Object.keys(data).filter(function(key){
                  return isArrayOfContentId(master, dataPath + '/' + key);
                }).map(function(key) {
                  var objectArray = atex.onecms.ObjectUtils.getByPath(master, dataPath + '/' + key);
                  master.data.aspects.contentData.data[key] = replace(oldId, article.meta.id, objectArray);
                  master.data.contentUpdated = true;
                });
              }
              if ($rootScope.editChain !== undefined) {
                $rootScope.editChain.replace(master,0);
              }
              ArtContentStore.put(master).then(function() {
                $rootScope.$broadcast("onecms:content-saved", master);
                resolve(true);
              });
            } else {
              resolve(true);
              $rootScope.$broadcast("onecms:edit-content",true);
            }
          }).then(null, function (error) {
            delete article.isBeingSent;
            $rootScope.$broadcast("onecms:edit-content",true);
            reject(error);
          });
        }, function () {
          delete article.isBeingSent;
          $rootScope.$broadcast("onecms:edit-content",true);
          reject(false);
        });
      });
    };

    ArtCommonServices.prototype = {
      constructor: ArtCommonServices
    };

    return(ArtCommonServices);
  }]);
